var _path, _path2, _path3, _g, _path4, _path5, _path6, _path7, _path8, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVu(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 54,
    height: 40,
    fill: "none",
    viewBox: "0 0 54 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#009543",
    d: "M.3 0h53.4v40H.3z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#d21034",
    d: "M.3 0h53.4v20H.3z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "b",
    width: 54,
    height: 41,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M.3 0v40l25-16.4h28.4v-7.2H25.2z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "m.3 0 25 16.4h28.4v7.2H25.2L.3 40"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#fdce12",
    strokeWidth: 11.7,
    d: "m.3 0 25 16.4h28.4v7.2H25.2L.3 40"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeWidth: 6.4,
    d: "m.3 0 25 16.4h28.4m0 7.2H25.2L.3 40"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#fdce12",
    d: "M7.5 23.8v2.3a6 6 0 0 0 5.9-6.4c0-4.9-4.2-5.8-5.4-5.8s-5.1.9-5.1 4.9 3.8 4.4 4.5 4.4 3.5-.7 3.2-3.7a3 3 0 0 1-3 2.6c-2 0-3.3-1.5-3.3-3 0-1.4 1.3-3.4 3.4-3.4s3.7 1.9 3.7 3.8-1.5 4.3-3.9 4.3"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#fdce12",
    stroke: "#fdce12",
    strokeWidth: 0.1,
    d: "M5.8 20.9s1-2.1 3.5-3.6c-.3.1-2 1-3.5 3.6Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#fdce12",
    d: "M6 20.5s-.3-.6 0-.9c.2-.2.1.7.1.7l.1-.1v-1c.2 0 .1.8.1.8l.2-.2s-.2-.7 0-.8 0 .7 0 .7l.2-.2s0-.7.2-.8 0 .6 0 .6l.1-.2s0-.6.2-.7c.2-.2 0 .6 0 .6l.1-.2s0-.6.2-.7 0 .6 0 .6l.1-.2s0-.6.2-.7 0 .6 0 .6l.2-.2s0-.6.2-.7 0 .6 0 .6V18s.1-.6.4-.7c.2 0-.2.6-.2.6l.2-.1s.1-.6.3-.7-.2.6-.2.6l.2-.1s.2-.6.4-.6-.2.4-.2.4h.1s.3-.6.4-.4-.4.4-.4.4h-.1s.6-.2.7 0l-1 .2h.5c0 .2-.7.2-.7.2h-.2.6c0 .2-.7.2-.7.2l-.2.1h.6c-.1.2-.8.2-.8.2l-.2.2s.7-.2.6 0l-.8.2-.2.2s.7-.2.5 0-.7.2-.7.2l-.2.3s.7-.4.6-.2-.8.4-.8.4l-.1.2s.6-.4.5-.2-.7.4-.7.4v.2s.6-.5.6-.2-.8.3-.8.3v.2s.6-.4.6-.2-.8.3-.8.3z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#fdce12",
    stroke: "#fdce12",
    strokeWidth: 0.1,
    d: "M9.8 20.9h-.2s-.9-2.1-3.4-3.6c.3.1 2 1 3.6 3.6Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#fdce12",
    d: "M9.5 20.5s.3-.6 0-.9c-.2-.2 0 .7 0 .7l-.2-.1s.2-.8 0-1c-.2 0-.1.8-.1.8l-.1-.2V19c-.3-.1-.2.7-.2.7l-.1-.2s.1-.7-.1-.8 0 .6 0 .6l-.2-.2-.1-.7c-.2-.2 0 .6 0 .6l-.2-.2-.1-.7c-.2-.1 0 .6 0 .6l-.2-.2s0-.6-.2-.7 0 .6 0 .6l-.1-.2s0-.6-.3-.7.1.6.1.6l-.1-.1s-.1-.6-.3-.7c-.3 0 .1.6.1.6l-.1-.1s-.2-.6-.4-.7.2.6.2.6l-.1-.1s-.3-.6-.5-.6l.3.4h-.2s-.3-.6-.4-.4.4.4.4.4h.2s-.7-.2-.7 0l.8.2h.2-.6c.1.2.7.2.7.2h.2-.6c.1.2.7.2.7.2l.2.1h-.5c0 .2.8.2.8.2l.1.2s-.6-.2-.6 0l.8.2.2.2s-.7-.2-.5 0q.5.3.7.2l.2.3S8 19 8 19.2s.8.4.8.4l.1.2s-.6-.4-.5-.2.7.4.7.4l.1.2s-.7-.5-.7-.2c.1.2.8.3.8.3v.2s-.6-.4-.6-.2.8.3.8.3z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M.3 0h53.3v40H.3z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVu);
export default __webpack_public_path__ + "static/media/vu.ea1e46d280041278303decdcbe7a9dea.svg";
export { ForwardRef as ReactComponent };